'use client'

import './Modal.scss'

import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock-upgrade'
import cn from 'classnames'
import { useEffect, useRef } from 'react'
import Modal from 'react-modal'

Modal.setAppElement('body')

type Props = {
  children: React.ReactNode
  title?: string
  isOpen: boolean
  onChange?: (isOpen: boolean) => void
  position?: 'left' | 'right' | 'center'
}

function CustomModal({
  children,
  title,
  isOpen,
  onChange = (val) => !val,
  position = 'center',
}: Props) {
  const overlayRef = useRef<HTMLElement | null>(null)
  const contentRef = useRef<HTMLElement | null>(null)

  function closeModal() {
    onChange(false)
  }

  function handleAfterOpen() {
    if (overlayRef && overlayRef.current) {
      disableBodyScroll(overlayRef.current)
    }
  }

  function handleAfterClose() {
    clearAllBodyScrollLocks()
  }

  function handleRequestClose() {
    closeModal()
  }

  function overlayRefCb(node: HTMLDivElement) {
    overlayRef.current = node
  }

  function contentRefCb(node: HTMLDivElement) {
    contentRef.current = node
  }

  function handleClickClose(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault()

    closeModal()
  }

  useEffect(() => {
    return () => clearAllBodyScrollLocks()
  }, [])

  return (
    <>
      <Modal
        className={`ws-custom-modal ws-custom-modal--${position}`}
        overlayClassName={`ws-custom-overlay ws-custom-modal--${position}`}
        onAfterOpen={handleAfterOpen}
        onAfterClose={handleAfterClose}
        onRequestClose={handleRequestClose}
        closeTimeoutMS={0}
        contentLabel={title || ''}
        overlayRef={overlayRefCb}
        contentRef={contentRefCb}
        isOpen={isOpen}
      >
        <div className={`${cn('modal', `modal-position--${position}`)}`}>
          <div className={`${cn('modal__inner')}`}>
            <div className={`${cn('modal__header')}`}>
              <div className={`${cn('modal__title')}`}>{title}</div>

              <div className={`${cn('modal__button-close')}`}>
                <button onClick={handleClickClose}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 33 32"
                  >
                    <rect
                      width="26.409"
                      height="2.031"
                      rx="1.016"
                      transform="scale(1.01526 .9845) rotate(45 -3.594 12.137)"
                    ></rect>
                    <rect
                      width="26.409"
                      height="2.031"
                      rx="1.016"
                      transform="scale(1.01526 .9845) rotate(-45 32.946 5.028)"
                    ></rect>
                  </svg>
                </button>
              </div>
            </div>

            <div className={`${cn('modal__content')}`}>{children}</div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CustomModal
